module.exports = __webpack_public_path__ + "static/media/image16.7a0d941e.jpg";